import http from '@/components/services/http-common';
import * as moment from "moment/moment"

export const ROUTE = 'infoUpdateRequests';
// global api
class InfoUpdateApi {
  gets() {
    return http.get(`${ROUTE}`).then(r => r.data.data)
  }
  
  getEmployee() {
    return http.get(`${ROUTE}/employee`).then(r => r.data)
  }

  get(id) {
    return http.get(`${ROUTE}/${id}`).then(r => r.data.data)
  }

  post(data) {
    return http.post(`${ROUTE}`, data)
  }
  remove(id){
    return http.delete(`${ROUTE}/${id}`)
  }
  
  getFamilyTemp(id) {
    return http.get(`employeeFamilies/temp/${id}`).then(r => r.data)
  }

  getAltCity() {
    return http.get('addresses/cities').then(r => {
      return r.data
    })
  }
  
  getAltWard(cityId) {
    return http.get('addresses/wards?cityId='+cityId).then(r => {
      return r.data
    })
  }

}

export default new InfoUpdateApi();